import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { appPagesSections } from "../../helpers/data";
import { Button, Line, SideBar } from "../../Styles/Global.Styled";
import { useNavigate } from "react-router-dom";
import { css } from "styled-components";
import ProfileIcon from "../../Icons/ProfileIcon";
import Login from "../../Pages/Login";
import ClosePopupButton from "../Buttons/ClosePopupButton";

const sideBarStyle = css`
  box-sizing: border-box;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5vh;
  position: absolute;
  right: 0;
  width: 75vw;
  height: 100%;
  padding: 2.5vh 3vw;
  gap: 4vh;
`;
const pageBttn = css`
  font-size: 3vh;
  width: 75%;
`;
const mainBttnStyle = css`
  background-color: ${({ theme }) => theme.main};
  color: white;
  width: 50vw;
  font-size: 2.5vh;
  padding: 0.75vh;
  border-radius: 9px;
`;
const secBttnStyle = css`
  border: 2px solid ${({ theme }) => theme.main};
  color: ${({ theme }) => theme.main};
  width: 50vw;
  font-size: 2.5vh;
  padding: 0.75vh;
  border-radius: 9px;
`;
const bttnStyle = css`
  font-size: 2vh;
  gap: 0.5vh;
`;
const iconSize = { height: "2vh", width: "2vh" };

const MobileNavBar = ({ setPopUp }) => {
  const navigate = useNavigate();
  const { isLoggedIn, logout } = useContext(AuthContext);

  const handleClick = (pageURL) => {
    navigate(pageURL);
    return setPopUp({ isOpen: false });
  };

  return (
    <SideBar $baseStyle={sideBarStyle}>
      <ClosePopupButton setPopUp={setPopUp} />
      {appPagesSections.map((page) => (
        <Button
          key={page.name}
          $baseStyle={pageBttn}
          onClick={() => handleClick(page.url)}
        >
          {page.name}
        </Button>
      ))}
      <Line />
      {isLoggedIn ? (
        <>
          <Button
            $baseStyle={bttnStyle}
            onClick={() => handleClick("my-account")}
          >
            <ProfileIcon style={iconSize} /> My Account
          </Button>
          <Button $baseStyle={bttnStyle} onClick={() => logout()}>
            Logout
          </Button>
        </>
      ) : (
        <>
          <Button
            $baseStyle={mainBttnStyle}
            onClick={() =>
              setPopUp({
                isOpen: true,
                content: <Login setPopUp={setPopUp} />,
              })
            }
          >
            Login
          </Button>
          <Button
            $baseStyle={secBttnStyle}
            onClick={() => handleClick("register")}
          >
            Join us
          </Button>
        </>
      )}
    </SideBar>
  );
};

export default MobileNavBar;
